export default {
  "content": "<circle cx=\"29\" cy=\"24\" r=\"18\" fill=\"#4E4EDA\"/><circle cx=\"29\" cy=\"24\" r=\"16\" stroke=\"#fff\" stroke-width=\"4\" fill=\"none\"/><path d=\"M35.56 19.84l-2.553-.967a.388.388 0 00-.287.007l-6.127 2.6v2.927l-1.48-.574.007-2.92 6.28-2.666-2.386-.914h-.027L22.44 19.8a.167.167 0 00-.107.153v7.74c0 .074.04.134.107.16l6.347 2.714a.65.65 0 00.5.006c1.24-.486 6.38-2.766 6.38-2.766V20a.167.167 0 00-.107-.16z\" fill=\"#fff\"/>",
  "attrs": {
    "viewBox": "11 6 36 36",
    "width": "36",
    "height": "36",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};